import React from 'react'

const NavbarLoading = () => {
    return (
        <div>NavbarLoading</div>
    )
}

export default NavbarLoading